import React from 'react';
import { useParams } from 'react-router-dom';
import PaymentSuccess from '.';
const EnhancePaymentSuccess = () => {
    const { transaction_id } = useParams()
    return <PaymentSuccess transactionId={transaction_id} />;
};
export default EnhancePaymentSuccess;